angular
  .module('app')
  .controller('EditFilmController', EditFilmController);

EditFilmController.$inject = ['Session', '$rootScope', '$stateParams', 'Films'];

function EditFilmController(Session, $rootScope, $stateParams, Films) {
  var vm = this;
  var id = $stateParams.id;
  var cat = $stateParams.categoria;
  $rootScope.loading = true;

  var film = Films.get({id: id, cat: cat}).$promise;
  film.then(function (res) {
    res.any = parseInt(res.any, 10);
    $rootScope.loading = false;
    vm.film = res;
    vm.filmcat = $stateParams.categoria;
  });

  vm.send = function () {
    var modify = Films.save({id: id, cat: cat, info: vm.film}).$promise;
    modify.then(function () {
      $rootScope.loading = false;
      Session.go('dashboard.main');
    });
  };

  vm.maxtour = 3;
  vm.checkedtour = 0;
  vm.changeTour = function (item) {
    if (item === '1') {
      ++vm.checkedtour;
    } else {
      --vm.checkedtour;
    }
  };
  vm.maxdoc = 2;
  vm.checkeddoc = 0;
  vm.changeDoc = function (item) {
    if (item === '1') {
      ++vm.checkeddoc;
    } else {
      --vm.checkeddoc;
    }
  };

  if (!Session.id) {
    Session.go('main.index');
  }
}
